import React from 'react';

import { IDynamicList } from './components/ListItem/dynamicList';
import { ScheduleItemConnectionFragment } from './graphql/fragments/ScheduleItemConnectionFragment';
import { ScheduleItemFragment } from './graphql/fragments/ScheduleItemFragment';
import { ScheduleItemListFragment } from './graphql/fragments/ScheduleItemListFragment';
import { DynamicList, ScheduleItemsQuery, ScheduleItemType } from './index';
import { DynamicFilterListType } from './types';

interface IScheduleItemSelect {
    onChange?: (value: string | string[]) => void;
    disabled?: boolean;
    filterList?: DynamicFilterListType[];
    mode?: 'multiple';
    style?: React.CSSProperties;
    // localFilters?: RowsFilterType;
    maxTagCount?: number | 'responsive';
    filterFlexible?: string;
    checkAccessPermission?: (item: any) => boolean;
}

const outScheduleItemSelect = React.forwardRef<IDynamicList, IScheduleItemSelect>(({ onChange, ...restProps }, ref) => {
    return (
        <DynamicList
            ref={ref}
            query={ScheduleItemsQuery}
            fragmentList={ScheduleItemListFragment}
            fragmentConnection={ScheduleItemConnectionFragment}
            fragment={ScheduleItemFragment}
            nameQuery={'scheduleItems'}
            fields={['name'] as (keyof ScheduleItemType)[]}
            template={'name'}
            onChange={(value: string | string[]) => {
                onChange?.(value);
            }}
            countRecord={100}
            {...restProps}
        />
    );
});

export default outScheduleItemSelect;
